import { render, staticRenderFns } from "./SampleDeleteDialog.vue?vue&type=template&id=5b2767a0"
import script from "./SampleDeleteDialog.vue?vue&type=script&lang=js"
export * from "./SampleDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports